<script setup lang="ts">
import { ref } from "vue";
import VueMarkdown from "vue-markdown-render";
import Button from "./Button.vue";
import OKCancelModal from "./OKCancelModal.vue";

const props = defineProps<{
  /** The label/title of the selected scenario shown in the modal header. */
  title: string;
  /** Raw markdown content fetched from the .md file. */
  markdown: string;
}>();

const copyStatus = ref<"idle" | "copied" | "error">("idle");

function setCopyStatus(status: "copied" | "error"): void {
  copyStatus.value = status;
  globalThis.setTimeout(() => {
    copyStatus.value = "idle";
  }, 1800);
}

async function copyRawMarkdown(): Promise<void> {
  try {
    if (typeof navigator.clipboard.writeText === "function") {
      await navigator.clipboard.writeText(props.markdown);
      setCopyStatus("copied");
      return;
    }

    setCopyStatus("error");
  } catch {
    setCopyStatus("error");
  }
}
</script>

<template>
  <OKCancelModal :title="title" ok-button-text="Close">
    <div class="test-scenario-doc-toolbar">
      <span
        v-if="copyStatus === 'copied'"
        class="test-scenario-doc-copy-feedback"
      >
        Copied
      </span>
      <span
        v-else-if="copyStatus === 'error'"
        class="test-scenario-doc-copy-feedback test-scenario-doc-copy-feedback-error"
      >
        Copy failed
      </span>
      <Button variant="secondary" @click="void copyRawMarkdown()">
        Copy Raw Markdown
      </Button>
    </div>
    <div class="test-scenario-doc-markdown">
      <VueMarkdown :source="markdown" />
    </div>
  </OKCancelModal>
</template>
